export const UFS = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
];
const UF_CODIGOS = {
  11: "RO",
  12: "AC",
  13: "AM",
  14: "RR",
  15: "PA",
  16: "AP",
  17: "TO",
  21: "MA",
  22: "PI",
  23: "CE",
  24: "RN",
  25: "PB",
  26: "PE",
  27: "AL",
  28: "SE",
  29: "BA",
  31: "MG",
  32: "ES",
  33: "RJ",
  35: "SP",
  41: "PR",
  42: "SC",
  43: "RS",
  50: "MS",
  51: "MT",
  52: "GO",
  53: "DF",
};
export const MEIOS_PAGAMENTO = [
  ["01", "Dinheiro"],
  ["02", "Cheque"],
  ["03", "Cartão de crédito"],
  ["04", "Cartão de débito"],
  ["05", "Crédito loja"],
  ["10", "Vale alimentação"],
  ["11", "Vale refeição"],
  ["12", "Vale presente"],
  ["13", "Vale combustível"],
  ["14", "Duplicata mercantil"],
  ["15", "Boleto bancário"],
  ["16", "Depósito bancário"],
  ["17", "PIX dinâmico"],
  ["18", "Transferência bancária / carteira digital"],
  ["19", "Cashback"],
  ["20", "PIX"],
  ["21", "Crédito em loja"],
  ["99", "Outros"],
].map(([value, text]) => ({ value, text: `${value} - ${text}` }));
export const STATUS = {
  pendente: ["Pendente", "secondary"],
  enviando: ["Em transmissão", "info"],
  registrado: ["Registrado", "success"],
  cancelado: ["Cancelado", "dark"],
  rejeitado: ["Rejeitado", "danger"],
  erro: ["Erro", "danger"],
  incerto: ["Aguardando confirmação", "warning"],
  descartado: ["Descartado", "secondary"],
};
const CAMPOS_PAGAMENTO = [
  "indPag",
  "tPag",
  "xPag",
  "vPag",
  "dPag",
  "CNPJPag",
  "UFPag",
  "CNPJIF",
  "tBand",
  "cAut",
  "CNPJReceb",
  "UFReceb",
];
export function hoje() {
  const data = new Date();
  return [
    data.getFullYear(),
    String(data.getMonth() + 1).padStart(2, "0"),
    String(data.getDate()).padStart(2, "0"),
  ].join("-");
}
export function ufDaNota(nota) {
  return UF_CODIGOS[String(nota?.chave || "").slice(0, 2)] || "";
}
export function podeAbrirEconf(nota) {
  return (
    !!nota?.id &&
    /^\d{44}$/.test(String(nota.chave || "")) &&
    !!ufDaNota(nota) &&
    [55, 65].includes(Number(String(nota.chave).slice(20, 22))) &&
    [2, 3].includes(Number(nota.status))
  );
}
export function configuracaoPadrao(uf = "") {
  return {
    uf,
    habilitado: false,
    obrigatorio: false,
    envio_automatico: false,
    somente_posteriores: true,
    inicio_vigencia: hoje(),
    fundamento_legal: "",
  };
}
export function novaReferencia() {
  const id =
    typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  return `web-econf:${id}`;
}
export function novoPagamento(nota = null) {
  const cnpj = /^\d{44}$/.test(String(nota?.chave || ""))
    ? String(nota.chave).slice(6, 20)
    : "";
  const uf = ufDaNota(nota);
  return {
    indPag: "1",
    tPag: "20",
    xPag: "",
    vPag: "",
    dPag: hoje(),
    CNPJPag: cnpj,
    UFPag: uf,
    CNPJIF: "",
    tBand: "",
    cAut: "",
    CNPJReceb: cnpj,
    UFReceb: uf,
  };
}
export function pagamentoDaConta(conta) {
  const bruto =
    Number(conta.valor_liquido || 0) +
    Number(conta.valor_taxa_administracao || 0);
  const codigo =
    Number(conta.id_meio_pagamento) === 17
      ? "20"
      : String(conta.id_meio_pagamento || "").padStart(2, "0");
  return {
    ...novoPagamento(),
    tPag: MEIOS_PAGAMENTO.some((item) => item.value === codigo) ? codigo : "99",
    vPag: (bruto > 0 ? bruto : Number(conta.valor || 0)).toFixed(2),
    dPag: String(conta.data_recebimento || "").slice(0, 10),
  };
}
export function limparPagamento(pagamento) {
  const dados = {};
  CAMPOS_PAGAMENTO.forEach((campo) => {
    let valor = String(pagamento[campo] ?? "").trim();
    if (campo.startsWith("CNPJ"))
      valor = valor.toUpperCase().replace(/[^A-Z0-9]/g, "");
    if (valor) dados[campo] = valor;
  });
  if (dados.tPag !== "99") delete dados.xPag;
  if (/^\d+(\.\d{1,2})?$/.test(dados.vPag || ""))
    dados.vPag = Number(dados.vPag).toFixed(2);
  return dados;
}
export function validarPagamentos(pagamentos) {
  if (!pagamentos.length || pagamentos.length > 100)
    return "Informe de 1 a 100 pagamentos.";
  for (let i = 0; i < pagamentos.length; i++) {
    const p = limparPagamento(pagamentos[i]);
    const prefixo = `Pagamento ${i + 1}: `;
    if (!MEIOS_PAGAMENTO.some((item) => item.value === p.tPag))
      return prefixo + "selecione o meio de pagamento.";
    if (
      !/^\d+(\.\d{1,2})?$/.test(p.vPag || "") ||
      Number(p.vPag) <= 0 ||
      Number(p.vPag) > 9999999999999.99
    )
      return prefixo + "informe um valor positivo com até duas casas decimais.";
    if (
      !/^\d{4}-\d{2}-\d{2}$/.test(p.dPag || "") ||
      Number.isNaN(Date.parse(p.dPag + "T12:00:00")) ||
      new Date(p.dPag + "T00:00:00Z").toISOString().slice(0, 10) !== p.dPag ||
      p.dPag > hoje()
    )
      return (
        prefixo + "informe a data efetiva do recebimento, sem data futura."
      );
    if (p.tPag === "99" && (!p.xPag || p.xPag.length < 2 || p.xPag.length > 60))
      return prefixo + "descreva o meio de pagamento (2 a 60 caracteres).";
    if (!["0", "1"].includes(p.indPag))
      return prefixo + "selecione à vista ou a prazo.";
    for (const campo of ["CNPJPag", "CNPJIF", "CNPJReceb"]) {
      if (p[campo] && !/^[A-Z0-9]{12}\d{2}$/.test(p[campo]))
        return prefixo + "confira o CNPJ informado.";
    }
    for (const [cnpj, uf] of [
      ["CNPJPag", "UFPag"],
      ["CNPJReceb", "UFReceb"],
    ]) {
      if (!!p[cnpj] !== !!p[uf] || (p[uf] && !UFS.includes(p[uf])))
        return prefixo + "informe CNPJ e UF juntos.";
    }
    if ((p.CNPJIF || p.tBand || p.cAut) && !p.CNPJPag)
      return (
        prefixo +
        "informe o CNPJ e a UF do estabelecimento que processou a transação."
      );
    if (p.tBand && !/^\d{2}$/.test(p.tBand))
      return prefixo + "a bandeira deve ter dois dígitos.";
    if (p.cAut && p.cAut.length > 128)
      return prefixo + "a autorização deve ter até 128 caracteres.";
  }
  return "";
}
export function contaComEventoAtivo(conta) {
  return (conta.econf_eventos || []).some(
    (evento) =>
      Number(evento.tipo_evento) === 110750 &&
      !["cancelado", "rejeitado", "descartado"].includes(evento.status)
  );
}
export function erroEconf(
  erro,
  fallback = "Não foi possível concluir a operação."
) {
  const dados = erro?.response?.data;
  const mensagens = dados?.errors
    ? Object.values(dados.errors).flat().filter(Boolean)
    : [];
  return (
    mensagens.join(" ") ||
    dados?.msg ||
    dados?.message ||
    erro?.message ||
    fallback
  );
}
export function moeda(valor) {
  return Number(valor || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}
export function dataFormatada(valor) {
  if (!valor) return "—";
  const data = String(valor).slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(data)
    ? data.split("-").reverse().join("/")
    : String(valor);
}
